import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useV2ListLineOfBusinessesForAccountQuery } from "@generated";
import { AdminFormPage } from "@components/CatalogIndex";
import { LobApprovalForm } from "../LobApprovalForm/LobApprovalForm";
import { useLobApprovalsList } from "../api/useLobApprovalsList";
import { useLobApprovalMutations } from "../api/useLobApprovalMutations";
import type { LobApprovalFormValues } from "../types/LobApproval";

const FORM_ID = "lob-approval-form";

const initial: LobApprovalFormValues = {
  sectionId: null,
  requiredApprovals: 1,
  submitterMayApprove: false,
  limitApprovalsToTeam: false,
};

export const New = () => {
  const navigate = useNavigate();
  const { create } = useLobApprovalMutations();
  const { rows: existing } = useLobApprovalsList();
  const { data: sectionsData } = useV2ListLineOfBusinessesForAccountQuery({});
  const [submitting, setSubmitting] = useState(false);

  const allSections = (sectionsData?.data ?? []).map((s: any) => ({
    id: String(s.id),
    name: s.attributes?.name ?? "",
  }));
  const usedSectionIds = new Set(existing.map((e) => e.sectionId));
  const availableSections = allSections.filter(
    (s: any) => !usedSectionIds.has(s.id)
  );

  const handleSubmit = async (values: LobApprovalFormValues) => {
    setSubmitting(true);
    try {
      const result: any = await create(values);
      const newId = result?.data?.id;
      navigate(newId ? `../${newId}/edit` : "..");
    } catch (err) {
      console.error("Failed to create lob_approval", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminFormPage
      title="Add an Approval"
      formId={FORM_ID}
      onCancel={() => navigate("..")}
      isSubmitting={submitting}
    >
      <LobApprovalForm
        id={FORM_ID}
        initialValues={initial}
        availableSections={availableSections}
        isSubmitting={submitting}
        onSubmit={handleSubmit}
      />
    </AdminFormPage>
  );
};
